import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=66908da2&"
import script from "./SearchPanel.vue?vue&type=script&lang=ts&"
export * from "./SearchPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports